export const Endpoints = {
  Account: {
    Profile: "auth/profile",
    ChangePassword: "auth/ChangePassword",
    UpdatePassword: "auth/UpdatePassword",
    UpdateProfile: "auth/UpdateProfile",
  },
  Bank: {
    main: "bank",
    lookup: "bank/lookup",
  },
  Companies: {
    main: "settings/companies",
    lookup: "settings/companies/lookup",
  },
  Transactions: {
    main: "transactions",
  },
  Categories: {
    main: "categories",
    lookup: "categories/lookup",
  },
  Departments: {
    main: "settings/departments",
    lookup: "settings/departments/lookup",
  },
  Roles: {
    main: "settings/groups",
    lookup: "settings/groups/lookup",
    addPermission: (id: string) => `settings/groups/${id}/permissions`,
    permissions: (id: string) => `settings/groups/${id}/permissions`,
    deletePermission: (id: string, permissionId: string) =>
      `settings/groups/${id}/permissions/${permissionId}`,
  },
  Permission: {
    main: "settings/permissions",
    lookup: "settings/permissions/lookup",
  },
  Employee: {
    main: "settings/employees",
    lookup: "settings/employees/lookup",
    documents: "employees/documents",
    accounts: "employees/accounts",
    roles: (id: string) => `settings/employees/${id}/groups`,
    createAccount: (id: string) => `employees/${id}/account`,
    addToRole: (id: string) => `settings/employees/${id}/groups`,
    removeFromRole: (id: string, roleId: string) =>
      `settings/employees/${id}/groups/${roleId}`,
    job: (id: string) => `employees/${id}/job`,
    createPassword: (id: string) => `settings/employees/setpassword/${id}`,
    activate: (id: string) => `settings/employees/activate/${id}`,
    revoke: (id: string) => `settings/employees/${id}/revoke`,
    deactivate: (id: string) => `settings/employees/deactivate/${id}`,
    changePassword: (id: string) => `settings/employees/${id}/changePassword`,
    deleteAddress: (id: string, addressId: string) =>
      `employees/${id}/Address/${addressId}`,
    deleteAccount: (id: string, accountId: string) =>
      `employees/${id}/Account/${accountId}`,
  },
  Tasks: {
    main: "settings/tasks",
    lookup: "settings/tasks/lookup",
    pending: "settings/tasks?status=1",
  },
  Dashboards: {
    main: "settings/dashboard",
    numberOfTasks: "settings/dashboard/numberoftasks",
    numberOfTaskLineItems: "settings/dashboard/numberoftasklineitems",
    numberOfCompanies: "settings/dashboard/numberofcompanies",
    numberOfUsers: "settings/dashboard/numberofusers",
    numberOfCompletedTasks: "settings/dashboard/numberoftaskcompleted",
    numberOfPendingTasks: "settings/dashboard/numberoftaskpending",
  },
  TaskDetails:{
    main: "settings/taskdetails",
    lookup: "settings/taskdetails/lookup",
    inProgress: (id: string) => `settings/taskdetails/${id}/markinprogress`,
    done: (id: string) => `settings/taskdetails/${id}/markcompleted`,

  },
  Comments: {
    main: "settings/taskactivitycomments",
    lookup: "settings/taskactivitycomments/lookup",
  },
  Jobs: {
    main: "jobs",
    lookup: "jobs/lookup",
  },
  Sectors: {
    main: "sectors",
    lookup: "sectors/lookup",
  },
  Sites: {
    main: "sites",
    lookup: "sites/lookup",
  },
  Partners: {
    main: "partners",
    lookup: "partners/lookup",
  },
  Projects: {
    main: "projects",
    lookup: "projects/lookup",
    employees: (id: string | number) => `projects/${id}/employees`,
    sites: (id: string | number) => `projects/${id}/sites`,
    activities: (id: string | number) => `projects/${id}/activities`,
    activitiesLookup: "projects/activities/Lookup",
  },
  Items: {
    main: "items",
    lookup: "items/lookup",
  },
  Orders: {
    main: "orders",
    lookup: "orders/lookup",
    actions: (id: string | number) => `orders/${id}/actions`,
    bids: (id: string | number) => `orders/${id}/bids`,
    Inventories: (id: string | number) => `orders/${id}/inventory`,
    approveBid: (id: string | number, bidId: number) =>
      `orders/${id}/bids/${bidId}`,
  },
  Supplier: {
    main: "suppliers",
    lookup: "suppliers/lookup",
  },
  DeductionTypes: {
    main: "deductiontypes",
    lookup: "deductiontypes/lookup",
  },
  OverTimeTypes: {
    main: "overtimetypes",
    lookup: "overtimetypes/lookup",
  },
  HumanRelations: {
    main: "humanrelations",
    lookup: "humanrelations/lookup",
  },
  AllowanceTypes: {
    main: "allowancetypes",
    lookup: "allowancetypes/lookup",
  },
  UnitTypes: {
    main: "unitTypes",
    lookup: "unitTypes/lookup",
  },
  LeaveTypes: {
    main: "leavetypes",
    lookup: "leavetypes/lookup",
  },
  EmergencyContacts: {
    main: "emergencycontacts",
  },
  Leaves: {
    main: "leaves",
  },
  OverTimes: {
    main: "overtimes",
  },
  Allowances: {
    main: "allowances",
  },
  Deductions: {
    main: "deductions",
  },
  Positions: {
    main: "positions",
  },
  Contracts: {
    main: "contracts",
  },
  Receipts: {
    main: "receipts",
  },
  Payments: {
    main: "payments",
  },
};
